export let props = ['title', 'describe']
export let model = {}
export let computed = {}
